import { render, staticRenderFns } from "./collection-sidebar-filters.vue?vue&type=template&id=46f7ca15&scoped=true&"
import script from "./collection-sidebar-filters.vue?vue&type=script&lang=js&"
export * from "./collection-sidebar-filters.vue?vue&type=script&lang=js&"
import style0 from "./collection-sidebar-filters.vue?vue&type=style&index=0&id=46f7ca15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f7ca15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VIcon,VRadio,VRadioGroup})
